var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticipantsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,10c-1.1,0.6-2.4,1-3.8,1c-4.4,0-8-3.6-8-8c0-1.1,0.2-2.1,0.6-3c-0.2,0-0.4,0-0.6,0H12C5.4,0,0,5.4,0,12 v16c0,6.6,5.4,12,12,12h16c6.6,0,12-5.4,12-12V12C40,11.3,39.9,10.7,39.8,10z M20,9c3,0,5.5,2.5,5.5,5.5S23,20,20,20 s-5.5-2.5-5.5-5.5S17,9,20,9z M31,29.6c0,0.8-0.6,1.4-1.4,1.4H10.4C9.6,31,9,30.4,9,29.6v-1.4c0-4.8,7.3-6.2,11-6.2s11,1.4,11,6.2 V29.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsActive);
export default __webpack_public_path__ + "static/media/participants_active.8f9b0caa4c8312a143875790b797add5.svg";
export { ForwardRef as ReactComponent };